import { render, staticRenderFns } from "./ImportUpload.vue?vue&type=template&id=bfc0ca22"
import script from "./ImportUpload.vue?vue&type=script&lang=js"
export * from "./ImportUpload.vue?vue&type=script&lang=js"
import style0 from "./ImportUpload.vue?vue&type=style&index=0&id=bfc0ca22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports